module.exports = __webpack_public_path__ + "resource/img/own-file.b0fe70ef.svg";